/** @format */

export const APP_NAME = 'wemi';
